import { Component, OnInit } from '@angular/core';
import { Order, OrderSend } from './Models/Order';
import { Inspector } from './Models/inspektor';
import { ViewJSONComponent } from '../form-v2/form-control/controls/view-json/view-json.component';
import { MatDialog } from '@angular/material/dialog';
import { FormV2ServiceService } from '../form-v2/form-v2-service.service';
@Component({
  selector: 'app-inspector-viewer',
  templateUrl: './inspector-viewer.component.html',
  styleUrls: ['./inspector-viewer.component.scss']
})



export class InspectorViewerComponent implements OnInit {

openCount = 1;
inspector:Inspector;
page = 1;
constructor(public dialog: MatDialog, private formService: FormV2ServiceService) {

    }
  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (!input.files || input.files.length === 0) {
      return;
    }

    const file = input.files[0];
    const reader = new FileReader();

    reader.onload = () => {
      const content = reader.result as string;
      const lines = content
        .split(/\r?\n/)
        .map(line => line.trim())
        .filter(line => line.length > 0);

      this.inspector.orders = lines.map(orderNumber => ({
        Id : 0,
        orderNumber,
        status: 'Nowe',
        statusDes: '',
        oldTechTime: undefined,
        newTechTime: undefined,
        notes: '',
        details: '',
        start:0,
        sync: true
      }));
      this.inspector.saveOrdersToStorage();
      this.SaveAllOrders(true);
    };

    reader.readAsText(file);
  }
  GetAllOrders() {
    this.formService.GetOrderTests().
    subscribe((data) => {
      // console.log("tests odebrany", data);
      
     this.inspector.orders = [];

      data.forEach(e => {
        var o = new Order();
        o.Id = e.Id;
        o.orderNumber= e.OrderNumber;
        o.status = e.Status;
        o.statusDes = null; //e.StatusDes;
        o.oldTechTime = null; //e.OldTechTime;
        o.newTechTime = null; //e.NewTechTime;
        o.oldTechParams =null;
        o.newTechParams = null;
        /*if(e.OldTechParams != null){
          o.oldTechParams =  JSON.parse(e.OldTechParams);
        }
        if(e.NewTechParams != null){
          o.newTechParams =  JSON.parse(e.NewTechParams);
        }*/
         o.notes = null;
         o.details = null;
        /*if(e.Notes != null && e.Notes != ""){
          o.notes =  JSON.parse(e.Notes);
        }
        if(e.Details != null && e.Details != ""){
          o.details =  JSON.parse(e.Details);
        }*/
        
        o.start = 0;
        o.sync = false;
        if(o.status == "Nowe"){
          this.inspector.orders.push(o);
        }
        
      });
      this.inspector.saveOrdersToStorage();
    });

  }

  SaveAllOrders(loadAfter) {
/*
this.inspector.orders.forEach(e => {
  if((e.oldTechTime != null && e.newTechTime == null) || (e.sync && e.status != "Zakończony")){
    e.status = "Nowe";
    e.ParamsDif = null;
    e.newTechParams = null;
    e.oldTechParams = null; 
    e.sync = false;
  }
});
*/
console.log("all", this.inspector.orders);
    // console.log("orders1", this.inspector.orders);
    var no = this.inspector.orders.filter(x => x.Id == 0 || x.sync == true || x.status == "Zakończony");
console.log("no", no);
    // console.log("zapis", no);
    if(no.length > 0){
      this.inspector.orders = this.inspector.orders.filter(x => x.Id != 0 && x.sync != true);
      this.inspector.saveOrdersToStorage();
      var toSync = [];
      no.forEach(e => {
        var o = new OrderSend();
        o.Id = e.Id;
        o.orderNumber= e.orderNumber;
        o.status = e.status;
        o.statusDes = e.statusDes;
        o.oldTechParams = JSON.stringify(e.oldTechParams);
        o.newTechParams = JSON.stringify(e.newTechParams);
        o.oldTechTime = e.oldTechTime;
        o.newTechTime = e.newTechTime;
        try {
          if(e.ParamsDif != null && e.ParamsDif.length > 0){
            o.ParamsDif = JSON.stringify(e.ParamsDif);
          }
        } catch(Exception){
            o.ParamsDif = o.ParamsDif;
        }
         
        //newTechTime: undefined,
        o.notes = JSON.stringify(e.notes);
        o.details = JSON.stringify(e.details);
        o.start = e.start;
        toSync.push(o);
        e.oldTechParams = [];
        e.newTechParams = [];
      });
      try {
        this.inspector.saveOrdersToStorage();
      } catch(Exception){

      }
      // console.log("save orders", toSync);
      this.formService.SaveOrderTests(toSync).
      subscribe((data) => {
        
        

        // console.log("tests", data);
        if(loadAfter){
          // console.log("wczytuje wszystko ponownie");
          // this.GetAllOrders();
        }

        
      });
      if(loadAfter){
        this.inspector.orders = [];
        this.inspector.saveOrdersToStorage();
      }
      
    }
    

  }
  displayTime(value?: number): string | number {
    return value !== undefined && value !== null ? value : '-';
  }


ngOnInit(): void {
    this.inspector = new Inspector();
    this.inspector.dialog = this.dialog;
    this.powtarzaj();
    this.powtarzaj2_init();
  }
powtarzaj(){
  //this.inspector.loadOrdersFromStorage();
  //this.GetAllOrders();
  //setTimeout(() => {  this.powtarzaj(); }, 10 * 60 * 1000);
}
powtarzaj2_init(){
  setTimeout(() => {  this.powtarzaj2(); }, 10000);
}
powtarzaj2(){
  this.inspector.loadOrdersFromStorage();
  this.SaveAllOrders(false);
  setTimeout(() => {  this.powtarzaj2(); }, 5000);
}
openNewTabs(): void {
  const count = Number(this.openCount);

  if (!count || count <= 0) {
    return; 
  }
 var licznik = 0;
  for (var i = 0; i< this.inspector.orders.length;i++) { 
    // console.log("o", this.inspector.orders[i]); 
    if(this.inspector.orders[i].status == "Nowe"){
      this.inspector.orders[i].status = "Przetwarzanie (Nowa tech)";
      this.inspector.orders[i].statusDes = "Przetwarzanie (Nowa tech)";
      this.inspector.orders[i].start = Date.now();
      window.open('/Testuj/N/Copy/FR/'+this.inspector.orders[i].orderNumber, '_blank');
      this.inspector.saveOrdersToStorage();
      licznik++;
    }
    if(licznik >= count){
      break;
    }
  };
  
}

showObj(i){
  var dialogRef = this.inspector.dialog.open(ViewJSONComponent, {
      maxWidth: Math.round(window.innerWidth * 0.6569),
      // maxHeight: Math.round(window.innerHeight * 0.9595),
      width: '100%',
      // height: '100%',
      disableClose: false,
      data: this.inspector.orders[i],
    });
}
showParamsS(i){
   const data = {
      Params: this.inspector.orders[i].oldTechParams
    }; 
  var dialogRef = this.inspector.dialog.open(ViewJSONComponent, {
      maxWidth: Math.round(window.innerWidth * 0.6569),
      // maxHeight: Math.round(window.innerHeight * 0.9595),
      width: '100%',
      // height: '100%',
      disableClose: false,
      data: data,
    });
}

showParamsN(i){
  const data = {
      Params: this.inspector.orders[i].newTechParams
    }; 
  var dialogRef = this.inspector.dialog.open(ViewJSONComponent, {
      maxWidth: Math.round(window.innerWidth * 0.6569),
      // maxHeight: Math.round(window.innerHeight * 0.9595),
      width: '100%',
      // height: '100%',
      disableClose: false,
      data: data,
    });
}
showParamsDif(i){
  const data = {
      Params: this.inspector.orders[i].ParamsDif
    }; 
  var dialogRef = this.inspector.dialog.open(ViewJSONComponent, {
      maxWidth: Math.round(window.innerWidth * 0.6569),
      // maxHeight: Math.round(window.innerHeight * 0.9595),
      width: '100%',
      // height: '100%',
      disableClose: false,
      data: data,
    });
}

formatMs(ms?: number): string {
  if (ms === undefined || ms === null) {
    return '-';
  }

  const totalSeconds = Math.floor(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  const milliseconds = ms % 1000;

  return `${minutes}m ${seconds.toString().padStart(2, '0')}.${milliseconds
    .toString()
    .padStart(3, '0')}s`;
}


clearOrders(): void {
  const confirmed = confirm('Czy na pewno chcesz usunąć to wszystkie zlecenia?');

  if (!confirmed) {
    return;
  }

  this.inspector.orders = [];
  localStorage.removeItem("lista_zlecen");
}

removeOrder(index: number): void {
  // console.log("ordern", index);
const confirmed = confirm('Czy na pewno chcesz usunąć to zlecenie?');

  if (!confirmed) {
    return;
  }

  this.inspector.orders.splice(index, 1);
  this.inspector.saveOrdersToStorage();

}

clearOrderData(index: number): void {
  // console.log("ordern", index);
  const confirmed = confirm(
    'Czy wyczyścić wszystkie dane zlecenia?'
  );

  if (!confirmed) {
    return;
  }

  const orderNumber = this.inspector.orders[index].orderNumber;
  const Id = this.inspector.orders[index].Id;

  this.inspector.orders[index] = {
        Id,
    orderNumber,
    status: 'Nowe',
    statusDes: '',
    oldTechTime: undefined,
    newTechTime: undefined,
    notes: '',
    details: '',
    start: 0,
    sync: true
  };

  this.inspector.saveOrdersToStorage();
}


}
